<template>
  <transition
    name="fade"
    v-on:afterEnter="afterEnter"
    v-on:beforeLeave="beforeLeave"
  >
    <div class="modal-user" v-if="show">
      <!-- <div class="modal-user__backdrop" @click="closeModal()" /> -->
      <div ref="draggableContainer" id="draggable-container">
        <SpinnerLoader
          v-if="loading"
          :color="colors.primary"
          class="modal-loader"
        />
        <div class="modal-user__dialog" :style="cssStyle">
          <!-- Dialog content -->

          <!-- Dialog headline -->
          <div
            class="modal-user__header"
            id="draggable-header"
            @mousedown="dragMouseDown"
            @touchstart="mobileDragStart($event)"
            @touchmove="mobileDragMove($event)"
          >
            <div class="d-flex draggable-header-part">
              <p class="modal-user__header__title h6">
                {{ title }}
              </p>
              <img src="@/assets/drag-icon.png" alt="Drag image" />
            </div>
            <p v-if="editMode" class="mt-0">
              <btn-link
                :type="'button'"
                :class="'remove-participant'"
                @click.native.prevent="onRemove"
                :label="$t('general.removeParticipant')"
              />
            </p>
          </div>

          <!-- Dialog confirm message -->
          <div v-if="showConfirmMessage" class="confirm">
            <div class="modal-user__body">
              <p class="text-size-12 mb-3 intro" v-html="confirmText"></p>
              <div class="button-row text-right">
                <Btn
                  :type="'submit'"
                  @click.native.prevent="onConfirm"
                  :label="labelBtnConfirm"
                />
              </div>
            </div>
          </div>

          <!-- Dialog add and edit mode  -->
          <div v-if="!showConfirmMessage" class="main-dialog">
            <div class="modal-user__body">
              <div v-if="!editMode" class="mb-2">
                <p class="text-size-12 mb-1 intro" v-html="intro"></p>
                <ShowDetails
                  v-if="showCollapsable"
                  :details="introDetails"
                  :collapsable="true"
                />
              </div>

              <form
                class="form text-left text-dark-grey"
                role="form"
                autocomplete="off"
                id="formParticipantModal"
                novalidate
              >
                <div class="form-group">
                  <!-- Participant name  -->
                  <div class="participant-row">
                    <div class="participant-name">
                      <input-text-validated
                        ref="name"
                        :label="$t('participantModal.participantName')"
                        rules="required"
                        type="text"
                        id="modalUserName"
                        autocomplete="off"
                        v-model="userName"
                        v-on:keydown.enter.prevent="onSubmit"
                      />
                    </div>
                  </div>

                  <!-- Participant email  -->
                  <div v-if="!editMode" class="mt-2">
                    <div class="small font-italic" v-if="1">
                      <input-text-validated
                        ref="email"
                        :label="emailLabel"
                        :rules="{ required: needEmail, email: true }"
                        type="email"
                        vid="email"
                        id="email"
                        :readonly="readonly"
                        v-model="userEmail"
                        autocomplete="off"
                      />
                    </div>
                    <span
                      class="text-danger text-size-12"
                      v-if="0 && emailIsMissing"
                    >
                      {{ $t('warnings.invalidEmail') }}
                    </span>
                  </div>
                  <div
                    v-if="editMode && participantEmail"
                    class="small mt-2 readonly-email"
                  >
                    <label class="k-label email-label">{{
                      $t('participantModal.participantEmailAddress')
                    }}</label>
                    <div>{{ participantEmail }}</div>
                  </div>

                  <!-- Participant attributes  -->
                  <div
                    v-for="attribute in attributeValues"
                    :key="attribute.id"
                    class="mt-2"
                  >
                    <div class="participant-name">
                      <input-text-validated
                        :ref="'attributeelement'"
                        :label="attribute.label"
                        :rules="attribute.mandatory == true ? 'required' : ''"
                        type="text"
                        :id="attribute.id"
                        autocomplete="off"
                        v-model="attribute.value"
                        v-on:keydown.enter.prevent="onSubmit"
                      />
                    </div>
                    <div
                      class="text-danger text-size-12"
                      v-if="0 && attribute.missing"
                    >
                      Pflichtfeld
                    </div>
                  </div>
                </div>

                <div class="form-group" v-if="offerCommentsSubscription">
                  <ToggleOption
                    v-model="receiveCommentReminder"
                    icon="edit"
                    class="mt-1"
                    :disabled="false"
                    :separator="false"
                  >
                    <span class="toggle-option-text-small">
                      {{ $t('participantModal.settingSubscribe') }}
                    </span>
                  </ToggleOption>
                </div>

                <div
                  class="form-group"
                  v-if="hideForAdmin && getPollOwner && participantEmail"
                >
                  <ToggleOption
                    v-model="isParticipantIsSubAdmin"
                    icon="edit"
                    class="mt-1"
                    :disabled="!isPremium"
                    :separator="false"
                  >
                    <span class="toggle-option-text-small">
                      {{ $t('participantModal.subAdminParticipant') }}
                      <label class="col-2 col-form-label new-premium-label">
                        New
                      </label>
                      <img
                        class="ml-1 mr-2 flex-column border-radius premium-logo-design"
                        height="50"
                        srcset="/images/PremiumFavicon.png"
                        alt=""
                      />
                    </span>
                  </ToggleOption>
                </div>

                <div class="button-row text-right">
                  <btn-link
                    :type="'button'"
                    @click.native.prevent="closeModal"
                    :label="$t('participantModal.cancel')"
                  />
                  <Btn
                    :type="'submit'"
                    @click.native.prevent="onSubmit"
                    :label="labelBtnSave"
                  />
                </div>
              </form>
            </div>

            <div v-if="isPublicLink" class="modal-user__footer text-size-12">
              {{ $t('participantModal.footerPublicInvite') }}
            </div>
          </div>
        </div>
      </div>
      <ModalConfirm
        v-if="editParticipant"
        v-show="showConfirmDelete"
        :msg="titleConfirmDete"
        @confirm="deleteConfirmed"
        :loading="deleting"
        @cancel="showConfirmDelete = false"
      />
    </div>
  </transition>
</template>

<script>
import { HTTP } from '@/shared/http';
import ToggleOption from '@/components/Edit/ToggleOption.vue';
import ShowDetails from '@/components/UI/ShowDetails.vue';

import { extend, localize } from 'vee-validate';
import {
  required,
  email,
  min,
  required_if,
  confirmed,
} from 'vee-validate/dist/rules';
import de from 'vee-validate/dist/locale/de.json';

import { SpinnerLoader } from 'vue-spinners-css';
import colors from '@/styles/colors.scss';
import { mapState, mapGetters } from 'vuex';
import { constants } from '@/shared/constant';

extend('required', required);
extend('required_if', required_if);
extend('confirmed', confirmed);

extend('email', email);
extend('min', min);

localize('de', de);

export default {
  name: 'ModalParticipant',
  props: ['user', 'invitation', 'editMode', 'editParticipant', 'isNewUser'],
  components: {
    ToggleOption,
    ShowDetails,

    SpinnerLoader,
  },
  data() {
    return {
      disabled: false,
      colors: colors,
      showConfirmDelete: false,
      showConfirmMessage: false,
      deleting: false,
      show: false,
      loading: false,
      userId: this.user ? this.user.id : null,
      userName: null,
      nameIsMissing: false,
      userEmail: this.user ? this.user.email : null,
      emailIsMissing: false,
      password: null,
      password_confirmation: null,
      passwordIsMissing: false,
      passwordConfirmIsMissing: false,
      passwordsDoNotMatch: false,
      invalidEmail: this.$t('warnings.invalidEmail'),
      registrationSuccessful: false,

      showAdminOnly:
        this.editMode && this.editParticipant
          ? this.editParticipant.show_admin_only
          : false,
      receiveCommentReminder: true,
      isParticipantIsSubAdmin: false,

      attributeValues: null,

      tabIndex: 0,
      // saveMode = 1 on login, 2 on register
      saveMode: null,
      isLoginOrRegistrationSuccess: false,

      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0,
        mx: 0,
        my: 0,
      },
    };
  },

  watch: {
    user: function (newVal, oldVal) {
      if (newVal && !this.editMode) {
        this.$nextTick(function () {
          this.userName = newVal.name;
          console.error('userName changed');
        });
      }
      console.log('Prop changed: ', newVal, ' | was: ', oldVal);
    },

    userEmail: function (newVal) {
      if (newVal) {
        this.receiveCommentReminder = true;
      } else {
        this.receiveCommentReminder = false;
      }
      console.log('Prop email changed: ', this.receiveCommentReminder);
    },
  },

  computed: {
    ...mapGetters([
      'isPublicLink',
      'isOwner',
      'isPremium',
      'getOwnerParticipantName',
      'getPollOwner',
    ]),

    ...mapState({
      poll: (state) => state.poll.poll,
      curInvitation: (state) => state.curInvitation,
    }),

    readonly() {
      if (this.disabled) return true;
      return this.editMode;
    },

    emailLabel() {
      if (this.needEmail) {
        return this.$t('participantModal.participantEmailMandatory');
      }
      return this.$t('participantModal.participantEmailOptional');
    },

    title() {
      if (this.showConfirmMessage) {
        return this.$t('participantModal.confirmTitle');
      }

      if (this.editMode) {
        return this.$t('participantModal.titleEdit');
      }
      if (this.isPublicLink) {
        return (
          this.$t('participantModal.titlePublicLink') +
          '"' +
          this.poll.title +
          '"'
        );
      }
      return this.$t('participantModal.titleNew');
    },

    polltype() {
      switch (this.poll.type) {
        case 1:
          return this.$t('polls.typePoll');

        case 2:
          return this.$t('polls.typeEvent');

        case 3:
          return this.$t('polls.typeSurvey');

        default:
          return this.$t('general.undefinedPoll');
      }
    },

    showCollapsable() {
      if (!this.isPublicLink) return true;
      if (this.poll.options.mandatoryEmail) return false;
      return true;
    },

    confirmText() {
      const msg = this.$t('participantModal.confirmText').replaceAll(
        '%s',
        this.polltype
      );

      return msg.replaceAll('%e', this.userEmail);
    },

    intro() {
      if (this.isPublicLink) {
        const intoText = this.$t('participantModal.introPublicLink', {
          userName: '„' + this.getOwnerParticipantName + '“',
          pollType: this.polltype,
        });

        const resource = this.poll.options.mandatoryEmail
          ? 'participantModal.introPublicLinkMandatroyEmail'
          : 'participantModal.introPublicLinkOptionalEmail';
        const intoText2 = this.$t(resource, {
          userName: '„' + this.poll.user.name + '“',
          pollType: this.polltype,
        });

        return intoText + '<br/>' + intoText2;
      }
      const intoText = this.$t('participantModal.introAdmin', {
        userName: '„' + this.poll.user.name + '“',
        pollType: this.polltype,
      });
      return intoText;
    },

    introDetails() {
      if (this.editMode) {
        return null;
      }
      //return this.$t('invite.usingPublicLinkDetails');
      return this.$t('participantModal.introAdminDetails');
    },

    titleConfirmDete() {
      let title = this.$t('participantModal.confirmDelete');
      const name = this.editParticipant.name;
      title = title.replace('%s', name);
      return title;
    },

    participantEmail() {
      if (this.invitation) return this.invitation.email;

      if (this.editMode) {
        if (this.editParticipant.user) return this.editParticipant.user.email;
        return null;
      }
      if (this.user) {
        return this.user.email;
      }
      return null;
    },

    offerCommentsSubscription() {
      if (this.isPublicLink) {
        return true;
      }
      return this.participantEmail != null;
    },

    offerRegistration() {
      if (this.user) return false;
      // check also for private invitation
      if (this.invitation) return false;
      //return true;
      return false;
    },
    disableCommentToggle() {
      if (this.userEmail) return false;
      if (this.poll.options.mandatoryEmail) return false;
      return true;
    },
    needEmail: function () {
      if (this.isOwner || this.editMode) return false;
      return this.poll.options.mandatoryEmail;
    },
    hasValidEmail: function () {
      if (!this.userEmail) return false;
      return this.reg.test(this.userEmail);
    },

    labelBtnSave() {
      //console.log("labelBtnSave editMode:", this.editMode, this.$t('participantModal.save'));
      if (this.editMode) return this.$t('participantModal.save');
      else if (this.isPublicLink)
        return this.$t('participantModal.btnParticipate');
      return this.$t('participantModal.add');
    },

    labelBtnConfirm() {
      //console.log("labelBtnSave editMode:", this.editMode, this.$t('participantModal.save'));
      return this.$t('participantModal.btnContinue');
    },

    cssStyle() {
      let maxWidth =
        window.screen.width * constants.participantModalMaxHeightInPercentage;
      console.log(maxWidth);
      maxWidth =
        maxWidth > constants.participantModalMaxHeight
          ? constants.participantModalMaxHeight
          : maxWidth;
      return `width:${maxWidth}px;`;
    },
    hideForAdmin() {
      if (this.editParticipant && this.editParticipant.user) {
        return this.poll.user.id != this.editParticipant.user.id;
      }
      return false;
    },
  },
  methods: {
    closeModal() {
      this.show = false;
      console.log('ModalParticipant:closeModal called');
      document.querySelector('body').classList.remove('overflow-hidden');
      this.$emit('cancel');
    },
    openModal() {
      console.log(
        'openModal called',
        this.receiveCommentReminder,
        this.showAdminOnly
      );
      this.$nextTick(function () {
        this.show = true;
        document.querySelector('body').classList.add('overflow-hidden');
        this.resetValues();
        console.log(
          'openModal nextTick called',
          this.receiveCommentReminder,
          this.showAdminOnly
        );
      });
    },
    deleteConfirmed() {
      this.deleting = true;
      this.$store
        .dispatch('removeParticipant', this.editParticipant)
        .then(() => {
          this.deleting = false;
          this.showConfirmDelete = false;
          this.closeModal();
          this.$emit('removed');
        });
    },

    afterEnter() {
      let form = document.getElementById('formParticipantModal');
      let vm = this;
      this.resetValues();
      console.log(
        'afterEnter called',
        this.receiveCommentReminder,
        this.showAdminOnly
      );
      if (form) {
        form.addEventListener(
          'submit',
          function (event) {
            vm.onFormSubmit(form, event);
          },
          false
        );
      } else {
        console.log('no form');
      }
    },

    defaultRreceiveCommentReminder() {
      let defaultValue = true;
      if (!this.poll.options.mandatoryEmail && !this.userName) {
        defaultValue = false;
      }
      let value =
        this.editMode && this.editParticipant
          ? this.editParticipant.receive_comment_reminder
          : defaultValue;
      return value;
    },

    resetValues() {
      this.userId = this.user ? this.user.id : null;
      this.updateUserName();
      this.nameIsMissing = false;
      this.userEmail = this.user ? this.user.email : this.curInvitation?.email;
      this.emailIsMissing = false;
      this.password = null;
      this.password_confirmation = null;
      this.passwordIsMissing = false;
      this.passwordConfirmIsMissing = false;
      this.passwordsDoNotMatch = false;
      this.invalidEmail = this.$t('warnings.invalidEmail');
      this.registrationSuccessful = false;
      if (this.editParticipant) {
        this.isParticipantIsSubAdmin = this.editParticipant.is_sub_admin == 1;
      }
      this.showAdminOnly =
        this.editMode && this.editParticipant
          ? this.editParticipant.show_admin_only
          : false;
      this.receiveCommentReminder = this.defaultRreceiveCommentReminder();

      this.tabIndex = 0;
      this.saveMode = null;
      this.showConfirmMessage = false;

      this.attributeValues = this.poll.participant_attributes;
      for (const attribute of this.attributeValues) {
        this.$set(attribute, 'missing', false);

        const field = this.editParticipant
          ? this.editParticipant.attributes.find(
              (e) => e.name == attribute.name
            )
          : null;

        if (field) {
          this.$set(attribute, 'value', field.value);
        } else {
          this.$set(attribute, 'value', null);
        }
      }
    },

    onSelectTab(e, index) {
      console.log(e, index);
      this.saveMode = index + 1;
    },

    onFormSubmit(form, event) {
      console.log('onFormSubmit called');
      if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
        console.log('checkValidity false');
      }
      form.classList.add('was-validated');
    },

    beforeLeave() {
      console.log('beforeLeave called');

      let form = document.getElementById('formParticipantModal');
      if (form) {
        form.removeEventListener('submit', this.onFormSubmit);
        form.classList.remove('was-validated');
      }
      this.registrationSuccessful = false;
    },

    handleLoginError: function (code) {
      if (code == 'invalidAccount') {
        this.invalidEmail = 'login.acountNotFound';
        this.emailIsMissing = true;
        return;
      }

      if (code == 'invalidPassword') {
        this.passwordIsMissing = true;
        return;
      }
    },
    onRemove() {
      console.log('Delete user:', this.editParticipant);
      this.showConfirmDelete = true;
    },

    onConfirm() {
      this.closeModal();
    },

    onSubmit() {
      console.log('onSubmit called. saveMode:', this.saveMode);
      // if login or register

      const nameElement = this.$refs.name;
      nameElement.validate();
      if (this.userName == null || this.userName.trim() == '') return;

      const emailElement = this.$refs.email;
      if (emailElement) {
        emailElement.validate();
      }

      const inputElement = this.$refs.attributeelement;

      if (inputElement) {
        const count = inputElement.length;

        for (let i = 0; i < count; i++) {
          const element = inputElement[i];
          element.validate();
        }
      }

      if (this.userEmail && !this.hasValidEmail) {
        this.emailIsMissing = true;
        return;
      }

      if (this.needEmail && !this.hasValidEmail) {
        this.emailIsMissing = true;
        return;
      }
      this.emailIsMissing = false;

      for (const attribute of this.attributeValues) {
        if (attribute.mandatory && attribute.value == null) {
          attribute.missing = true;
          return;
        }
      }

      console.log('email OK');

      if (this.saveMode) {
        if (!this.password) {
          this.passwordIsMissing = true;
          return;
        }
        this.passwordIsMissing = false;

        console.log('password OK');

        let email = this.userEmail;
        let password = this.password;

        this.loading = true;
        if (this.saveMode === 1) {
          this.$store
            .dispatch('signin', { email, password })
            .then((response) => {
              this.loading = false;
              if (response.data && response.data.error) {
                this.handleLoginError(response.data.code);
              } else {
                this.isLoginSuccess = true;
                this.toggleRegister();
              }
            })
            .catch((error) => {
              this.loading = false;
              console.error(error);
            });
        } else if (this.saveMode === 2) {
          if (!this.userName) {
            this.nameIsMissing = true;
            return;
          }
          this.nameIsMissing = false;
          console.log('name OK');

          if (!this.password_confirmation) {
            this.passwordConfirmIsMissing = true;
            return;
          }
          this.passwordConfirmIsMissing = false;

          console.log('pw confirm OK');

          if (this.password_confirmation !== this.password) {
            this.passwordsDoNotMatch = true;
            return;
          }

          this.passwordsDoNotMatch = false;

          console.log('passwords match OK');

          let password_confirmation = this.password_confirmation;
          let name = this.userName;
          console.log('Try to register with email:' + email);

          // ToDo - find the user loacle based on the browser
          const locale = 'de';
          HTTP.post('/register', {
            name,
            email,
            password,
            password_confirmation,
            locale,
          })
            .then((response) => {
              console.debug('Response after register:', response);
              this.loading = false;
              if (response.data.error) {
                this.emailIsMissing = true;
                this.invalidEmail = this.$t('warnings.emailAlreadyRegistered');
                console.log('registration failed');
                this.registrationSuccessful = false;
              } else {
                this.emailIsMissing = false;
                this.invalidEmail = this.$t('warnings.invalidEmail');
                this.registrationSuccessful = true;
                this.userName = response.data.name;
                this.userId = response.data.id;
                this.user = response.data;
                this.toggleRegister();
              }
            })
            .catch((error) => {
              this.loading = false;
              console.log(error);
            });
        }
      } else {
        let payload = {
          participantName: this.userName,
          participantEmail: this.userEmail,
          userId: this.userId,
          receiveCommentReminder: this.receiveCommentReminder,
          attributes: this.attributeValues,
          showAdminOnly: this.showAdminOnly,
          isSubAdmin: this.userEmail ? this.isParticipantIsSubAdmin : false,
        };
        this.$emit('save', payload);

        if (this.editMode) {
          this.closeModal();
          return;
        }

        if (this.userEmail == null || this.userEmail.length == 0) {
          this.closeModal();
          return;
        }
        //this.showConfirmMessage = true;
        this.closeModal();
        return;
      }
    },

    onRegister: function () {
      console.log('on Register');
    },

    onLogin() {
      this.$router.push({
        path: '/signin',
        query: { url: this.$router.currentRoute.fullPath },
      });
    },
    dragMouseDown: function (event) {
      event.preventDefault();
      // get the mouse cursor position at startup:
      this.positions.clientX = event.clientX;
      this.positions.clientY = event.clientY;
      this.positions.mx = this.$refs.draggableContainer.offsetLeft;
      this.positions.my = this.$refs.draggableContainer.offsetTop;
      document.onmousemove = this.elementDrag;
      document.onmouseup = this.closeDragElement;
    },
    elementDrag: function (event) {
      event.preventDefault();
      this.positions.movementX = this.positions.clientX - event.clientX;
      this.positions.movementY = this.positions.clientY - event.clientY;
      this.positions.clientX = event.clientX;
      this.positions.clientY = event.clientY;
      // set the element's new position:
      this.$refs.draggableContainer.style.top =
        this.$refs.draggableContainer.offsetTop -
        this.positions.movementY +
        'px';
      this.$refs.draggableContainer.style.left =
        this.$refs.draggableContainer.offsetLeft -
        this.positions.movementX +
        'px';
    },
    mobileDragStart(event) {
      this.positions.clientX = event.touches[0].clientX;
      this.positions.clientY = event.touches[0].clientY;
      this.positions.mx = this.$refs.draggableContainer.offsetLeft;
      this.positions.my = this.$refs.draggableContainer.offsetTop;
    },
    mobileDragMove(event) {
      var touch;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      let nx = touch.clientX - this.positions.clientX;
      let ny = touch.clientY - this.positions.clientY;
      let xPum = this.positions.mx + nx;
      let yPum = this.positions.my + ny;
      this.$refs.draggableContainer.style.left = xPum + 'px';
      this.$refs.draggableContainer.style.top = yPum + 'px';
    },
    closeDragElement() {
      document.onmouseup = null;
      document.onmousemove = null;
    },

    updateUserName() {
      if (this.editMode && this.editParticipant) {
        this.userName = this.editParticipant.name;
        return;
      }

      if (this.user) {
        this.userName = this.user.name;
        return;
      }

      if (this.curInvitation) {
        const invitedParticipant = this.poll.participants.find(
          (p) => p.id == this.curInvitation.participant_id
        );

        if (invitedParticipant) {
          this.userName = invitedParticipant.name;
        }
        return;
      }
    },
  },

  mounted() {
    this.receiveCommentReminder = this.defaultRreceiveCommentReminder();
    this.updateUserName();

    this.disabled = false;
    if (!this.isOwner) {
      if (this.curInvitation || this.userEmail) {
        this.disabled = true;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/style.scss';
$bg-color: rgba(255, 255, 255, 0.3);

ul {
  margin-bottom: 1px;
}

.modal-user {
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
}
.modal-user__backdrop {
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
}
.modal-user__dialog {
  border: 1px solid $mid-grey;
  background-color: #ffffff;
  position: relative;
  width: 470px;
  margin: 50px auto;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  z-index: 2;
  -webkit-transform: translate3d(0, 0, 0);
  @media screen and (max-width: 992px) {
    width: 90%;
  }
}
.modal-user__close {
  width: 30px;
  height: 30px;
}
.modal-user__header {
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 10px;
  display: flex;
  align-items: flex-start;
  font-size: $small;
  // justify-content: center;
  &__title {
    margin-top: 2px;
    color: $dark-grey;
    @media screen and (max-width: 481px) {
      font-size: $small;
    }
  }
}
.modal-user__body {
  padding: 10px 20px 10px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .intro {
    color: $dark-grey;
  }
}
.modal-user__footer {
  padding: 10px 20px 20px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.form-error {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.8rem;
  color: #dc3545;
}

.register-success-header {
  color: green;
  font-size: 1.2rem;
  font-weight: 800;
}

.register-success-text {
  font-size: 1rem;
  font-weight: 400;
}

.settings-toggle {
  text-align: center;
  color: $checked-color;
  text-decoration: underline;
}

.link {
  color: $checked-color;
  text-decoration: underline;
}

.additional-settings {
  margin-top: 1rem;
}

.info-line {
  display: flex;
  justify-content: center;
  flex-direction: row;
}

.info-box {
  display: flex;
  flex-direction: column;
  position: inherit;
}

.info-text {
  cursor: pointer;
}

.info-icon {
  margin-left: 0.25rem;
  cursor: pointer;
}

.kulibri-color {
  color: $checked-color;
}

.modal-loader {
  position: fixed;
  top: 45%;
  left: 45%;
  z-index: 10;
}

.participant-row {
  display: flex;
  flex-direction: row;
}

.participant-name {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.participant-icon {
  display: flex;
  flex-direction: column;
  flex-grow: 0;
}
.description {
  font-size: 0.65rem;
  margin-top: 1rem;
}

.email-label {
  margin-bottom: 0px;
}

#draggable-container {
  position: absolute;
  z-index: 9;
  left: 33%;
}
#draggable-header {
  z-index: 10;
  cursor: all-scroll;
  .draggable-header-part {
    img {
      height: 20px;
      width: 20px;
      margin-top: -7px;
      margin-left: 8px;
    }
  }
}

.d-flex {
  display: inline-flex;
  align-items: center;
}

.readonly-email {
  border-bottom: 1px solid $light-grey;
}

@media screen and (max-width: 481px) {
  .remove-participant {
    font-size: $very-small;
    padding-top: 0px !important;
  }
  #draggable-container {
    left: 5%;
  }
}

::v-deep .vue-tablist {
  display: table;
  width: 100%;
  text-align: center;
  li {
    cursor: pointer;
    display: table-cell;
    text-decoration: underline;
  }
}
</style>
